import { render, staticRenderFns } from "./SupplierAccountList.vue?vue&type=template&id=2ae73690"
import script from "./SupplierAccountList.vue?vue&type=script&lang=js"
export * from "./SupplierAccountList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports